import { UploadedDocument } from "../../../types/document";
import { isObject } from "./isObject";

export function isUploadedDocument(val: unknown): val is UploadedDocument {
  return (
    isObject(val) &&
    isObject(val.document) &&
    typeof val.documentId === "string" &&
    typeof val.document.size === "number" &&
    typeof val.document.type === "string"
  );
}
